import { useRpc, useRpcCall } from '#storefront/composables'
import type { GoldnerClubSubscribeData } from '~/types/goldnerClub'

const useGoldnerClub = () => {
  const { user, isLoggedIn } = useAgsUser()
  const isUnsubscribed = ref(false)
  const fetching = ref(false)
  const error = ref()
  const done = ref(false)
  const currentShop = useCurrentShop()
  const key = 'goldner-club-user-data'

  const {
    data,
    refresh,
    error: membershipDetailsError,
    status: membershipDetailsStatus,
  } = useRpc('getMembershipDetails', key, undefined)

  const unsubscribe = async () => {
    try {
      error.value = null
      fetching.value = true

      const call = useRpcCall('unsubscribeGoldnerClub')

      await call({
        customer_id: String(user.value?.id),
        shop_id: currentShop.value.shopId.toString(),
      })

      await refresh()

      isUnsubscribed.value = true
    } catch (err) {
      console.log('Unsubscribe from Goldner Club error', err)
      error.value = err
      isUnsubscribed.value = false
    }

    fetching.value = false
  }

  const subscribe = async (
    data: Omit<GoldnerClubSubscribeData, 'businessUnit'>,
  ) => {
    try {
      error.value = null
      fetching.value = true
      done.value = false

      const call = useRpcCall('subscribeGoldnerClub')

      await call({
        ...data,
      })

      await refresh()

      done.value = true
      return true
    } catch (err) {
      console.log('Subscribe to Goldner Club error', err)
      error.value = err
    }

    fetching.value = false
  }

  return {
    key,
    subscribe,
    isUnsubscribed,
    unsubscribe,
    fetching,
    error,
    done,
    data,
    getMembershipDetails: refresh,
    membershipDetailsError,
    membershipDetailsStatus,
  }
}

export default useGoldnerClub
